import { InjectionToken, type Provider } from '@angular/core';

export type FooterLink = { readonly label: string } & (
  | { readonly href: string; readonly routerLink?: never }
  | { readonly href?: never; readonly routerLink: string }
);

export interface FooterLinkGroup {
  readonly title: string;
  readonly links: readonly FooterLink[];
}

export interface AppFooterConfig {
  /** `apps/sbe-status/web`에 등록된 실제 앱 slug. 없으면 상태확인 링크를 렌더링하지 않는다. */
  readonly statusAppSlug?: string;
  /** 앱이 추가하는 사이트맵 그룹(개발자센터 등). */
  readonly linkGroups?: readonly FooterLinkGroup[];
}

export const APP_FOOTER_CONFIG = new InjectionToken<AppFooterConfig>('APP_FOOTER_CONFIG');

export function provideAppFooter(config: AppFooterConfig = {}): Provider {
  return { provide: APP_FOOTER_CONFIG, useValue: config };
}
